import { ORDERS_PRODUCT_FILTER_EVENTS } from './global-events';

export const ordersProductFilterOptions = [
  {
    id: 'all',
    name: 'Всі',
    event: ORDERS_PRODUCT_FILTER_EVENTS.ORDERS_PRODUCT_FILTER_ALL,
    options: {
      type: 'checkbox',
      activeFilter: false,
    }
  },
  {
    id: 'osago',
    name: 'ОСЦПВ',
    event: ORDERS_PRODUCT_FILTER_EVENTS.ORDERS_PRODUCT_FILTER_OSAGO,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'green_card',
    name: 'ЗК',
    event: ORDERS_PRODUCT_FILTER_EVENTS.ORDERS_PRODUCT_FILTER_GREEN_CARD,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'tourism',
    name: 'ТУРИЗМ',
    event: ORDERS_PRODUCT_FILTER_EVENTS.ORDERS_PRODUCT_FILTER_TOURISM,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'home',
    name: 'ЖИТЛО',
    event: ORDERS_PRODUCT_FILTER_EVENTS.ORDERS_PRODUCT_FILTER_HOME,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'manual',
    name: 'ЗОВНІШНІ ЗАМОВЛЕННЯ',
    event: ORDERS_PRODUCT_FILTER_EVENTS.ORDERS_PRODUCT_FILTER_EXTERNAL,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'miniKasko',
    name: 'МІНІКАСКО',
    event: ORDERS_PRODUCT_FILTER_EVENTS.ORDERS_PRODUCT_FILTER_MINI_KASKO,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'pets',
    name: 'СТРАХУВАННЯ ТВАРИН',
    event: ORDERS_PRODUCT_FILTER_EVENTS.ORDERS_PRODUCT_FILTER_PETS,
    options: {
      type: 'checkbox',
    },
  }
];
